import { useAuth } from "@/contexts/AuthContext";
import { useCurrentUser } from "@/hooks/useUsers";

interface ProjectMembership {
  memberIds: string[];
}

/**
 * Admin/Project Owner are the only roles that manage project setup (including
 * deletion). Project Owners are scoped to projects they belong to — mirrors
 * the visibility filter in AllProjects and the backend's require_project_editor.
 */
export function useProjectPermissions() {
  const { user } = useAuth();
  const { data: currentUser } = useCurrentUser();

  const isAdmin = user?.role === "Admin";
  const isProjectOwner = user?.role === "Project Owner";
  const canCreateProjects = isAdmin || isProjectOwner;

  const canEditProject = (project?: ProjectMembership | null): boolean => {
    if (isAdmin) return true;
    if (!isProjectOwner || !project || !currentUser) return false;
    return project.memberIds.includes(currentUser.id);
  };

  return { isAdmin, isProjectOwner, canCreateProjects, canEditProject };
}
